/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Order } from '../../models/order';

export interface ApiOrderOrdersOrderIdGet$Params {
  orderId: string;
  commitPosition?: number;
}

export function apiOrderOrdersOrderIdGet(http: HttpClient, rootUrl: string, params: ApiOrderOrdersOrderIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Order>> {
  const rb = new RequestBuilder(rootUrl, apiOrderOrdersOrderIdGet.PATH, 'get');
  if (params) {
    rb.path('orderId', params.orderId, {});
    rb.query('commitPosition', params.commitPosition, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Order>;
    })
  );
}

apiOrderOrdersOrderIdGet.PATH = '/api/order/orders/{orderId}';
